import React, { Component } from 'react';
import { Alert, Button, Form, FormGroup, Input, Label } from 'reactstrap';
import './ForgotPassword.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { resetPassword } from '../../store/resetPasswordActions';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: ''
    };
  }

  onSubmit(evt) {
    evt.preventDefault();
    this.props.resetPassword(this.state.email);
    return false;
  }

  render() {
    return (
      <div className="forgotpassword-container">
        {this.props.error && <Alert color="danger">{this.props.error}</Alert>}
        {this.props.success && <Alert color="success">We have sent you an email with the link to set a new password.</Alert>}
        <Form className={'forgotpassword-form'} onSubmit={e => this.onSubmit(e)}>
          <h2 className="mb-4">Reset your password</h2>
          <FormGroup>
            <Label for="email">Email address</Label>
            <Input
              type="email"
              id="email"
              placeholder="you@email.com"
              onChange={e => this.setState({ email: e.target.value })}
              required
            />
          </FormGroup>

          <Button color="primary" className="btn-block">
            Reset my password
          </Button>
        </Form>
      </div>
    );
  }
}

export { ForgotPassword };

const mapStateToProps = ({ resetPassword }) => {
  return {
    error: resetPassword.error,
    success: resetPassword.forgotPasswordSuccess
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      resetPassword
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPassword.js